import * as React from "react";
import { AmrSource } from "../api";

export const GENOMES_PER_PAGE = 30;
export const AMR_SOURCES: AmrSource[] = ["CARD", "ResFinder", "AMR Finder"];

export const CONSENT_COOKIE_NAME = "cookie-consent";
export const DISMISSED_BANNERS_COOKIE_NAME = "dismissed-banners";
export const STRIPE_REDIRECT_NOTICE_COOKIE_NAME = "stripe-redirect-notice";
export const AFTER_LOGIN_ACTION_COOKIE_NAME = "after-login-redirect-to";
export const DO_NOT_ASK_ABOUT_REDIRECTING_TO_OCX_COOKIE_NAME = "just-redirect-to-ocx";
export const RESTRICTED_COUNTRY_ARG_NAME = "restricted-country";

export const SIMULATED_COUNTRY_COOKIE_NAME = "debug-simulated-country";
export const SIMULATED_COUNTRY_HEADER_NAME = "X-Debug-Simulated-Country";

export const RESTRICTED_COUNTRY_PURCHASE_ERROR_MSG =
  "Cell Bio memberships are not available for purchase in your region.";
export const RESTRICTED_COUNTRY_DOWNLOAD_ERROR_MSG: React.ReactNode = (
  <>
    <strong>Access Restricted:</strong> ATCC restricts access to certain human cell line omics
    datasets for users accessing the website from jurisdictions identified as countries of concern
    under 28 CFR § 202.303. As a result, these datasets are not available for download. If you
    believe this restriction has been applied in error or have questions regarding access
    eligibility, please contact <a href="mailto:nextgen@atcc.org">nextgen@atcc.org</a>.
  </>
);

export const OPEN_ACCESS_GENOME_UUIDS: string[] = [
  "ec8c390b482542ee", // SARS-CoV-2
  "9fdf2eb2010942a7", // Human adenovirus 5
  "231e1b568ee14e91", // E. coli phage MS2
  "79f43b45f79b4abc", // S. aureus
  "b9d91f150db449de", // E. coli
  "080e20c7507b453b", // Exiguobacterium indicum
  "6547647b5a0f460d", // Moraxella catarrhalis
  "0fdc61a44a8f4582", // Candida albicans
  "36efe8d13467435c", // Aspergillus brasiliensis
];
